export default __webpack_public_path__ + "static/media/Exercise & Pills 1.a972f1bf.png";